import { getAccessToken, setAccessToken } from 'AccessToken'
import { ApolloLink, Observable } from 'apollo-boost'
import { InMemoryCache, InMemoryCache as UploadInMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient, ApolloClient as UploadApolloClient } from 'apollo-client'
import { split } from 'apollo-link'
import { onError } from 'apollo-link-error'
import { HttpLink } from 'apollo-link-http'
import { TokenRefreshLink } from 'apollo-link-token-refresh'
import { WebSocketLink } from 'apollo-link-ws'
import { createUploadLink } from 'apollo-upload-client'
import { getMainDefinition } from 'apollo-utilities'
import jwtDecode from 'jwt-decode'
import { getEnvConfig } from 'config/envConfig'

const apolloCache = new UploadInMemoryCache({
  addTypename: false,
})
export const cache = new InMemoryCache({
  addTypename: false,
})

/////////////////////////////////////////////////////////////////////////////////////////
// Runtime environment configuration
// Configuration is loaded from config.js at runtime, allowing build-once, deploy-many

// Get runtime configuration
const envConfig = getEnvConfig()

// Export configuration values
export const hotelxNodeUrl = envConfig.hotelxNodeUrl
export const hotelxSocketUrl = envConfig.hotelxSocketUrl
export const hotelXRefreshUrl = envConfig.hotelXRefreshUrl
export const PaymentUrl = envConfig.paymentUrl
export const ReportURL = envConfig.reportUrl
export const GoogleAPIKey = envConfig.googleAPIKey

const wsNodeUrl = envConfig.wsNodeUrl

export const requestLink = new ApolloLink(
  (operation, forward) =>
    new Observable(observer => {
      let handle: any
      Promise.resolve(operation)
        .then(operation => {
          const accessToken = getAccessToken()
          if (accessToken) {
            operation.setContext({
              headers: {
                authorization: `bearer ${accessToken}`,
              },
            })
          }
        })
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          })
        })
        .catch(observer.error.bind(observer))

      return () => {
        if (handle) handle.unsubscribe()
      }
    })
)

export const uploadLink = createUploadLink({
  uri: hotelxNodeUrl,
  credentials: 'include',
})
const wsLink = new WebSocketLink({
  uri: wsNodeUrl,
  options: {
    reconnect: true,
  },
})
const httpLink = new HttpLink({
  uri: hotelxNodeUrl,
  credentials: 'include',
})
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  wsLink,
  httpLink
)
export const WSclient = new ApolloClient({
  cache: cache,
  link: splitLink,
})

export const Uploadclient = new UploadApolloClient({
  cache: apolloCache,
  link: ApolloLink.from([requestLink, uploadLink]),
})

export const client = new ApolloClient({
  link: ApolloLink.from([
    new TokenRefreshLink({
      accessTokenField: 'accessToken',
      isTokenValidOrUndefined: () => {
        const token = getAccessToken()

        if (!token) {
          return true
        }

        try {
          const { exp } = jwtDecode(token)
          if (Date.now() >= exp * 1000) {
            return false
          } else {
            return true
          }
        } catch (err) {
          console.log(err)
          return false
        }
      },
      fetchAccessToken: () => {
        return fetch(hotelXRefreshUrl, {
          method: 'POST',
          credentials: 'include',
        })
      },
      handleFetch: accessToken => {
        setAccessToken(accessToken)
      },
      handleError: err => {
        console.warn('Your refresh token is invalid. Try to relogin')
        console.error(err)
      },
    }),
    onError(() => {}),
    requestLink,
    splitLink,
    // new HttpLink({
    //   uri: hotelxNodeUrl,
    //   credentials: 'include',
    // }), //new HttpLink ends here
  ]),
  cache,
})

// export const client = new ApolloClient({
//   cache: new InMemoryCache({
//     addTypename: false,
//   }),
//   uri: hotelxNodeUrl,
//   request: operation => {
//     // const token = localStorage.getItem('token')
//     const accessToken = getAccessToken()
//     operation.setContext({
//       headers: {
//         'keep-alive': 'true',
//         authorization: `bearer ${accessToken}`,
//       },
//     })
//   },
//   onError: error => {
//     error?.graphQLErrors?.map(({ message }) => {
//       console.log('message', message)
//       if (
//         message ===
//         'Context creation failed: Authentication token is invalid, please log in'
//       ) {
//         // browserHistory.push('/login', {})
//       }
//     })
//   },
// })
